import React, { useContext } from 'react';
import { LanguageContext } from "../languages/LanguageContext";
import { BiSolidRightArrow } from "react-icons/bi";
import GalleryPreview from "./GalleryPreview";

const NewsContainer = ({
    folder,
    title,
    date,
    content,
    addon,
    imageCount,
    prefix,
    suffix
}) => {
    const { language, translations } = useContext(LanguageContext);

    return (
        <div className='news-container max-w flex wrap jc-sb'>
            <div className='news-content flex col jc-sb'>
                <h2>{title}</h2>
                <h3>{date}</h3>
                <p dangerouslySetInnerHTML={{ __html: content }}></p>
                { addon &&
                    <a className='more-button' href={addon} target='_blank' rel="noreferrer"><BiSolidRightArrow className='icon' />{translations[language]["readMore"]} {translations[language]["here"]}!</a>
                }
            </div>
            { folder &&
                <GalleryPreview
                    folder={folder}
                    prefix={prefix}
                    suffix={suffix}
                    imageCount={imageCount}
                    news={true}
                />
            }
        </div>
    );
};

export default NewsContainer;